<div class="content-wrapper-inner">
  <div class="page-content">
    <div *ngIf="loading == true" class="spinner">
      <div class="sk-spinner sk-spinner-pulse"></div>
    </div>
    <app-special-pricing-group-form (onAfterSave)="afterSave()"></app-special-pricing-group-form>
  </div>
</div>
